<template lang="pug">
  button.button.is-outlined(type="button" @click="connectFacebook" :class="loading || fbLoading ? 'is-loading': ''")
    span.icon.has-text-facebook
      i.mdi.mdi-facebook
    |  &nbsp;
    span {{$t('signin.actions.facebook')}}
</template>

<script>
import FBHelper from '@/api/facebook'

export default {
  name: 'FacebookSignin',
  props: {
    loading: {type: Boolean}
  },
  data() {
    return {
      userAccessToken: undefined,
      fbLoading: false
    }
  },
  async created() {
    try {
      await FBHelper.getLoginState()
    } catch (err) {
      this.$handleAPIError(err)
    }
  },
  methods: {
    async processFBState(state) {
      if (state.auth === 'connected') {
        let token = await FBHelper.getUserAccessToken()
        this.userAccessToken = token.userAccessToken
        this.$emit('signedIn', {userAccessToken: this.userAccessToken})
      }
    },
    async connectFacebook() {
      this.fbLoading = true
      try {
        let state = await FBHelper.login(['email'])
        await this.processFBState(state)
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.fbLoading = false
    }
  }
}
</script>
